import { Route } from 'react-router-dom';
import { compose } from 'react-apollo';
import withTracker from 'hocs/withTracker';

const SimpleRoute = ({ component: C, props: cProps, ...rest }) => (
  <Route {...rest} render={props => <C {...props} {...cProps} userData={rest.userData} />} />
);

export default compose(withTracker)(SimpleRoute);
